const STYLES = {
  prototype: "bg-[#FEF3C7] text-[#92400E] border-[#FDE68A]",
  approved: "bg-[#ECFDF5] text-[#065F46] border-[#A7F3D0]",
  retired: "bg-[#F3F4F6] text-[#374151] border-[#E5E7EB]",
  planned: "bg-[#F4EFEA] text-[#6B584B] border-[#D8CBB8]",
  in_progress: "bg-[#E0E7FF] text-[#3730A3] border-[#C7D2FE]",
  completed: "bg-[#ECFDF5] text-[#065F46] border-[#A7F3D0]",
  cancelled: "bg-[#F3F4F6] text-[#374151] border-[#E5E7EB]",
  ok: "bg-[#ECFDF5] text-[#065F46] border-[#A7F3D0]",
  issue: "bg-[#FEF2F2] text-[#B91C1C] border-[#FECACA]",
  lab: "bg-[#F4EFEA] text-[#6B584B] border-[#D8CBB8]",
  experience_centre: "bg-[#F9F3E6] text-[#8A6D2F] border-[#E5C992]",
  cafe: "bg-[#ECE9FE] text-[#5B21B6] border-[#DDD6FE]",
  workshop: "bg-[#E0E7FF] text-[#3730A3] border-[#C7D2FE]",
  rating: "bg-[#F9F3E6] text-[#8A6D2F] border-[#E5C992]",
  comment: "bg-[#F4EFEA] text-[#6B584B] border-[#D8CBB8]",
  suggestion: "bg-[#E0E7FF] text-[#3730A3] border-[#C7D2FE]",
};

export default function StatusBadge({ value, testid }) {
  const cls = STYLES[value] || "bg-[#F4EFEA] text-[#6B584B] border-[#D8CBB8]";
  return (
    <span data-testid={testid} className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold border ${cls}`}>
      {(value || "").replace(/_/g, " ")}
    </span>
  );
}
